interface Props {
  name: string;
  role: string;
  category: string;
  birth_date: string;
  death_date: string;
  description: string;
}
const SliderActiveItem = ({
  name,
  role,
  category,
  birth_date,
  death_date,
  description
}: Props) => {
  return <div key={name} className='fade-to-left order-1 mt-4 flex flex-col items-center gap-4 lg:order-3 lg:mt-8 lg:gap-4' data-sentry-component="SliderActiveItem" data-sentry-source-file="slider-active-item.tsx">
            <div className='flex flex-col items-center gap-1 lg:gap-4'>
                <span className='block font-medium lg:text-lg'>{name}</span>
                <span className='block text-body-14 text-text-darkGray lg:text-base'>{role}</span>
            </div>
            <div className='flex items-center gap-2 rounded border border-border-gray-light px-2 py-1 text-caption-12 lg:px-3 lg:py-2 lg:text-body-14'>
                <span>{category}</span>
                <span className='hidden text-text-lightGray lg:inline'>{' | '}</span>
                <span className='hidden lg:inline'>
                    {birth_date} {' - '} {death_date}
                </span>
            </div>
            <p className='hidden lg:block'>{description}</p>
        </div>;
};
export default SliderActiveItem;